import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export const OpenService = Symbol('OpenService');

export interface OpenOptions {
    target?: '_blank' | '_self' | '_parent' | '_top';
    noopener?: boolean;
}

export interface OpenService {
    open(url: string, data: OpenOptions): void;
    openAsync(url: string, data: OpenOptions): Promise<void>;
}

@injectable()
export class OpenServiceImpl implements OpenService {
    constructor(

    ) {
        // pass
    }

    open(url: string, data: OpenOptions = {}): void {
        window.open(url, data.target ?? '_blank', data.noopener ? 'noopener' : '');
    }

    openAsync(url: string, data: OpenOptions = {}): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                const tab = window.open();
                if (data.noopener) {
                    tab!.opener = null;
                }
                tab!.location = url;
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }
}
